import coach from '@/api/coach';

import {
    FETCH_COACH,
    PATCH_COACH,
    FETCH_AVAILABLE_DATES,
    FETCH_AVAILABLE_TIMES,
    PATCH_COACH_PHONE,
    WECHAT_BIND_COACH,
    WECHAT_UNBIND_COACH,
} from './types';

export default {
    [FETCH_COACH]({ commit }) {
        return coach.get()
            .then((resp) => {
                commit(FETCH_COACH, resp);
            });
    },
    [PATCH_COACH]({ commit }, payload) {
        return coach.patch(payload)
            .then((resp) => {
                commit(FETCH_COACH, resp);
            });
    },
    [PATCH_COACH_PHONE]({ commit }, payload) {
        return coach.patchPhone(payload)
            .then((resp) => {
                commit(FETCH_COACH, resp);
            });
    },
    [WECHAT_BIND_COACH]({ commit, rootState }) {
        return coach
            .wechatBind({ openid: rootState.wechat.openid })
            .then((resp) => {
                commit(FETCH_COACH, resp);
            });
    },
    [WECHAT_UNBIND_COACH]({ commit }) {
        return coach
            .wechatUnbind()
            .then((resp) => {
                commit(FETCH_COACH, resp);
            });
    },
    [FETCH_AVAILABLE_DATES]({ commit }, payload) {
        return coach
            .getAvailableDates(payload.date)
            .then(resp => commit(FETCH_AVAILABLE_DATES, resp));
    },
    [FETCH_AVAILABLE_TIMES]({ commit }, payload) {
        return coach
            .getAvailableTimes(payload.date)
            .then(resp => commit(FETCH_AVAILABLE_TIMES, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/coach/actions.js